<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get, orderBy } from 'lodash';
import {
  isZoomMeetingAsAddonCard,
  additionalZoomSchedulerAsAddonCardCheck,
  isProPlusContext,
} from '@/plans/ZOOM_MEETING/common/utils';

export default {
  name: 'TranslationAddon',
  mixins: [base, planCommon],
  for: (args) => {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      if (isProPlusContext) return planTypes.map([planTypes.ZONE_PRO_PLUS]);
      if(['A', 'B', 'C'].includes(window?.newBillingConfig?.opcAddonExpansionTest??"")) return planTypes.map([ planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS ]);
      const GET_SELECTED_PLANS_INDEX = 2; // src/views/config/core.vue - function call - filterAddonForKeys
      return additionalZoomSchedulerAsAddonCardCheck(args[GET_SELECTED_PLANS_INDEX]) ? []: planTypes.map([ planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS ]);
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        this.planMapFlat.filter((p) => p.type === planTypes.TRANSLATION_CAPTIONS),
        ['participants', 'amount'],
        'asc',
      );
      return get(list, [0], {});
    },
  },
};
</script>
